module.exports = __webpack_public_path__ + "static/media/curve.2ff194c2.svg";